var React = require('react');

function HamburgerIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"icon-hamburger-dark","fill":"#000000"},React.createElement("path",{"d":"M10.0714286,20 L130.928571,20 C136.488,20 141,15.52 141,10 C141,4.48 136.488,0 130.928571,0 L10.0714286,0 C4.512,0 0,4.48 0,10 C0,15.52 4.512,20 10.0714286,20 L10.0714286,20 Z M130.928571,40 L10.0714286,40 C4.512,40 0,44.48 0,50 C0,55.52 4.512,60 10.0714286,60 L130.928571,60 C136.488,60 141,55.52 141,50 C141,44.48 136.488,40 130.928571,40 L130.928571,40 Z M130.928571,80 L10.0714286,80 C4.512,80 0,84.48 0,90 C0,95.52 4.512,100 10.0714286,100 L130.928571,100 C136.488,100 141,95.52 141,90 C141,84.48 136.488,80 130.928571,80 L130.928571,80 Z","id":"Shape"})));
}

HamburgerIcon.defaultProps = {"viewBox":"0 0 141 100","version":"1.1"};

module.exports = HamburgerIcon;

HamburgerIcon.default = HamburgerIcon;
